'use client';

import { Container, useModal } from '..';
import { PrimaryButton } from './styleConstants';
import { CircularTick } from '../../assets/icons';
import React from 'react';
import { CustomImage as Image } from '../shared';
import { UltraSignalTFModal } from './UltrasignalTF';
import styles from './HeroSection.module.css';

export const HeroSection = ({
  className,
  title,
  subtitle,
  ctaType,
  ctaDescription,
  ctaText,
  bg = 'dark',
  bulletPoints,
  imgSrc,
  iframe,
  align,
  tag,
}: {
  className?: string;
  title?: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  ctaType?: 'primary' | 'secondary';
  ctaDescription?: string | React.ReactNode;
  ctaText?: string | React.ReactNode;
  bg?: 'dark' | 'light';
  bulletPoints?: Record<string, string | React.ReactNode>[];
  imgSrc?: string;
  iframe?: string;
  align?: 'left' | 'center' | 'right';
  tag?: string;
}) => {
  const ModalClient = useModal();
  const showBookCallModal = () => {
    ModalClient.set(<UltraSignalTFModal />);
    ModalClient.setCloseButtonTheme('light');
    ModalClient.show();
  };

  return (
    <section
      className={`${styles.root}${className ? ` ${className}` : ''}`}
      style={
        {
          background: bg === 'dark' ? '#000' : 'rgb(238, 238, 238)',
          ['--hero-pad-top' as string]: imgSrc ? '42rem' : '20rem',
          ['--hero-place' as string]: imgSrc ? 'center' : 'unset',
          ['--bullet-color' as string]: bg === 'dark' ? '#fff9' : '#000',
        } as React.CSSProperties
      }
    >
      <Container
        className={
          'container ' +
          (align === 'left'
            ? styles.alignLeft
            : align === 'right'
            ? styles.alignRight
            : '')
        }
      >
        <p className={styles.tag}>{tag}</p>
        {/* <h1 className="caption">Women’s Health</h1> */}
        {title ? (
          <h2 className={bg === 'dark' ? styles.title : styles.titleLight}>
            {title}
          </h2>
        ) : null}
        {subtitle ? (
          <p
            className={
              bg === 'light'
                ? `${styles.subtitle} ${styles.subtitleLight}`
                : styles.subtitle
            }
          >
            {subtitle}
          </p>
        ) : null}
        {bulletPoints ? (
          <ul className="pointers">
            {bulletPoints.map((point, index) => (
              <li key={index}>
                <div className={styles.iconContainer}>
                  <CircularTick className={styles.bulletIcon} />
                </div>

                <span>
                  {Object.values(point).map((value, i) => (
                    <React.Fragment key={i}>{value}</React.Fragment>
                  ))}
                </span>
              </li>
            ))}
          </ul>
        ) : null}
        {ctaText ? (
          <div className={styles.ctaContainer}>
            {ctaDescription ? (
              <p className={styles.ctaContent}>{ctaDescription}</p>
            ) : null}
            <PrimaryButton
              className={ctaType === 'primary' ? 'light' : ''}
              onClick={showBookCallModal}
            >
              {ctaText}
            </PrimaryButton>
          </div>
        ) : null}
      </Container>
      {imgSrc ? (
        <div className={styles.imgContainer}>
          <Image
            className="ring-image"
            src={'web_v2/ring-buy/color-cta/rt-3.png/w_1920'}
            alt="Ulttahuman Ring AIR"
            width="565"
            height="569"
          />
        </div>
      ) : null}
      {/* <Image
              src={'web_v2/womens-health/hero/desktop.png'}
              alt="Hero Image"
              className="hero"
              fill
              priority
            /> */}
      {bg === 'dark' ? <div className={styles.overlay}></div> : null}
      {iframe ? (
        <div className={styles.iframeContainer}>
          <iframe
            title="Unicorn Studio"
            src={iframe}
            width="1440px"
            height="900px"
            loading="lazy"
          ></iframe>
        </div>
      ) : null}
    </section>
  );
};
